import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UnitsService } from 'src/app/services/units.service';

@Component({
  selector: 'app-unit-inovice',
  templateUrl: './unit-inovice.component.html',
  styleUrls: ['./unit-inovice.component.css']
})
export class UnitInoviceComponent implements OnInit {

  unit_Id:any
  unit_name:any
  utilty_arr:any = []
  service_arr :any = []
  other:any = []
  constructor(private activeRouter : ActivatedRoute, private unitServ:UnitsService){
   this.unit_Id = this.activeRouter.snapshot.paramMap.get('id');
   this.unit_name = this.activeRouter.snapshot.paramMap.get('name');
  }

  ngOnInit(){
    console.log(this.unit_Id , this.unit_name)
    this.unitServ.unit_invoice(this.unit_Id).subscribe((res:any) => {
      console.log(res)
      this.utilty_arr = res.utilities
      this.service_arr = res.services
      this.other = res.others
    })
  }

}
